import {
  CommonRequest,
  StatusTrackerResponse
} from '../../../models/api/tracker.interfaces';

export const StatusTrackerResponseMocks: StatusTrackerResponse = {
  loyaltyMemberId: '6490423602',
  carrierCode: 'DL',
  countryCode: 'US',
  personName: {
    namePrefixCode: 'Ms',
    firstName: 'Digital',
    lastName: 'Platinum'
  },
  enrolledInPromotionalStatus: false,
  hasFutureFlights: true,
  futureFlightCnt: 2,
  loyaltyMemberAnnualBalances: [
    {
      balanceStartLocalDate: '2024',
      loyaltyBalances: [
        {
          balanceTypeCode: 'CFM',
          balanceTypeDesc: 'Credited Flight Miles',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQDs',
          balanceTypeDesc: 'Medallion Qualifying Dollars',
          balanceAmt: 25000
        },
        {
          balanceTypeCode: 'COB',
          balanceTypeDesc: 'Cobrand - MQD Waiver',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'ROLL',
          balanceTypeDesc: 'Rollover MQMs',
          balanceAmt: 450000
        }
      ]
    },
    {
      balanceStartLocalDate: '2023',
      loyaltyBalances: [
        {
          balanceTypeCode: 'CFM',
          balanceTypeDesc: 'Credited Flight Miles',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQDs',
          balanceTypeDesc: 'Medallion Qualifying Dollars',
          balanceAmt: 25000
        },
        {
          balanceTypeCode: 'COB',
          balanceTypeDesc: 'Cobrand - MQD Waiver',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'ROLL',
          balanceTypeDesc: 'Rollover MQMs',
          balanceAmt: 450000
        }
      ]
    },
    {
      balanceStartLocalDate: '2022',
      loyaltyBalances: [
        {
          balanceTypeCode: 'CFM',
          balanceTypeDesc: 'Credited Flight Miles',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQM',
          balanceTypeDesc: 'Medallion Qualifying Miles',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQS',
          balanceTypeDesc: 'Medallion Qualifying Segments',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQDs',
          balanceTypeDesc: 'Medallion Qualifying Dollars',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'COB',
          balanceTypeDesc: 'Cobrand - MQD Waiver',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'ROLL',
          balanceTypeDesc: 'Rollover MQMs',
          balanceAmt: 0
        }
      ]
    },
    {
      balanceStartLocalDate: '2021',
      loyaltyBalances: [
        {
          balanceTypeCode: 'CFM',
          balanceTypeDesc: 'Credited Flight Miles',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQM',
          balanceTypeDesc: 'Medallion Qualifying Miles',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQS',
          balanceTypeDesc: 'Medallion Qualifying Segments',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'MQDs',
          balanceTypeDesc: 'Medallion Qualifying Dollars',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'COB',
          balanceTypeDesc: 'Cobrand - MQD Waiver',
          balanceAmt: 0
        },
        {
          balanceTypeCode: 'ROLL',
          balanceTypeDesc: 'Rollover MQMs',
          balanceAmt: 0
        }
      ]
    }
  ],
  loyaltyMemberProgramBalance: {
    balanceStartLocalDate: '1995-10-20',
    loyaltyBalances: [
      {
        balanceTypeCode: 'LCFM',
        balanceTypeDesc: 'Lifetime Credited Flight Miles',
        balanceAmt: 50510
      },
      {
        balanceTypeCode: 'LMQMs',
        balanceTypeDesc:
          'Lifetime Medallion Qualifying Miles (aka Million Miler)',
        balanceAmt: 750000
      },
      {
        balanceTypeCode: 'AVAIL',
        balanceTypeDesc: 'Available Miles',
        balanceAmt: 75296
      },
      {
        balanceTypeCode: 'TOTPGM',
        balanceTypeDesc: 'Total Program Miles',
        balanceAmt: 75296
      }
    ]
  },
  loyaltyMemberTierLevels: [
    {
      tierStatusDesc: 'PREVIOUS - 1',
      tierLevelClassificatinCode: 'MB',
      tierLevelCode: 'FF',
      tierLevelCodeDesc: 'SkyMiles Member',
      tierLevelStartLocalDate: '2021-02-01',
      tierLevelEndLocalDate: '2022-01-31',
      tierComp: false,
      tierMethodOfAttainmentCode: 'B2ET'
    },
    {
      tierStatusDesc: 'PREVIOUS',
      tierLevelClassificatinCode: 'MB',
      tierLevelCode: 'FF',
      tierLevelCodeDesc: 'SkyMiles Member',
      tierLevelStartLocalDate: '2022-02-01',
      tierLevelEndLocalDate: '2023-01-31',
      tierComp: false,
      tierMethodOfAttainmentCode: 'B2ET'
    },
    {
      tierStatusDesc: 'CURRENT',
      tierLevelClassificatinCode: 'MB',
      tierLevelCode: 'PM',
      tierLevelCodeDesc: 'Platinum Medallion',
      tierLevelStartLocalDate: '2023-02-01',
      tierLevelEndLocalDate: '2024-01-31',
      tierComp: false,
      tierMethodOfAttainmentCode: 'EPN23D',
      tierValidThruEndLocalDate: '2024-01-31',
      tierNextPeriodDowngrade: true,
      tierNextPeriodDowngradedTierLevelCode: 'FO',
      tierNextPeriodDowngradedTierLevelDesc: 'SIlver Medallion'
    },
    {
      tierStatusDesc: 'FUTURE',
      tierLevelClassificatinCode: 'MB',
      tierLevelCode: 'PM',
      tierLevelCodeDesc: 'Platinum Medallion',
      tierLevelStartLocalDate: '2025-02-01',
      tierLevelEndLocalDate: '2026-01-31',
      tierComp: false,
      tierMethodOfAttainmentCode: 'EPN23P'
    },
    {
      tierStatusDesc: 'FUTURE-FUTURE',
      tierLevelClassificatinCode: 'MB',
      tierLevelCode: 'FF',
      tierLevelCodeDesc: 'SkyMiles Member',
      tierLevelStartLocalDate: '2025-02-01',
      tierLevelEndLocalDate: '2026-01-31',
      tierComp: false
    }
  ],
  currentLoyaltyMemberMedallionStatus: [
    {
      programYearNum: '2024',
      programYearDesc: 'CURRENT',
      programYearStartLocalDate: '2024-02-01',
      programYearEndLocalDate: '2023-01-31',
      earnYearStartLocalDate: '2023-01-01',
      earnYearEndLocalDate: '2023-12-31',
      regionCode: 'ALL',
      eligibleMQDWaiver: false
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQD WAIVER'
        }
      ]
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQDs'
        }
      ]
    },
    {
      trackingToTierLevelCode: 'PM',
      trackingToTierLevelDesc: 'Platinum'
    },
    {
      loyaltyMemberThresholds: [
        {
          thresholdTypeCode: 'MQDs',
          thresholdTypeDesc: 'Medallion Qualifying Dollars',
          thresholdAmt: 18000,
          balanceAmt: 15300,
          remainderAmt: 2700,
          percentCompleteNum: '85.0%',
          percentRemainderNum: '15.0%',
          thresholdMet: false
        }
      ]
    }
  ],
  previousLoyaltyMemberMedallionStatus: [
    {
      programYearNum: '2023',
      programYearDesc: 'PREVIOUS',
      programYearStartLocalDate: '2023-02-01',
      programYearEndLocalDate: '2024-01-31',
      earnYearStartLocalDate: '2022-01-01',
      earnYearEndLocalDate: '2022-12-31',
      regionCode: 'US',
      eligibleMQDWaiver: false
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQS and MQD WAIVER'
        }
      ]
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQS and MQD'
        }
      ]
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQM and MQD WAIVER'
        }
      ]
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQM and MQD'
        }
      ]
    },
    {
      trackingToTierLevelCode: 'FO',
      trackingToTierLevelDesc: 'Silver'
    },
    {
      loyaltyMemberThresholds: [
        {
          thresholdTypeCode: 'MQM',
          thresholdTypeDesc: 'Medallion Qualifying Miles',
          thresholdAmt: 25000,
          balanceAmt: 0,
          remainderAmt: 25000,
          percentCompleteNum: '0.0%',
          percentRemainderNum: '100.0%',
          thresholdMet: false
        },
        {
          thresholdTypeCode: 'MQS',
          thresholdTypeDesc: 'Medallion Qualifying Segments',
          thresholdAmt: 30,
          balanceAmt: 0,
          remainderAmt: 30,
          percentCompleteNum: '0.0%',
          percentRemainderNum: '100.0%',
          thresholdMet: false
        },
        {
          thresholdTypeCode: 'COB',
          thresholdTypeDesc: 'Cobrand - MQD Waiver',
          thresholdAmt: 25000,
          spendPartnerCode: 'AXS',
          balanceAmt: 0,
          remainderAmt: 25000,
          percentCompleteNum: '0.0%',
          percentRemainderNum: '100.0%',
          thresholdMet: false
        }
      ]
    }
  ],
  previousMinus1LoyaltyMemberMedallionStatus: [
    {
      programYearNum: '2022',
      programYearDesc: 'PREVIOUS-1',
      programYearStartLocalDate: '2022-02-01',
      programYearEndLocalDate: '2023-01-31',
      earnYearStartLocalDate: '2021-01-01',
      earnYearEndLocalDate: '2021-12-31',
      regionCode: 'US',
      eligibleMQDWaiver: false
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQS and MQD WAIVER'
        }
      ]
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQS and MQD'
        }
      ]
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQM and MQD WAIVER'
        }
      ]
    },
    {
      medallionThresholdCombinations: [
        {
          thresholdCombinationDesc: 'MQM and MQD'
        }
      ]
    },
    {
      trackingToTierLevelCode: 'FO',
      trackingToTierLevelDesc: 'Silver'
    },
    {
      loyaltyMemberThresholds: [
        {
          thresholdTypeCode: 'MQM',
          thresholdTypeDesc: 'Medallion Qualifying Miles',
          thresholdAmt: 25000,
          balanceAmt: 0,
          remainderAmt: 25000,
          percentCompleteNum: '0.0%',
          percentRemainderNum: '100.0%',
          thresholdMet: false
        },
        {
          thresholdTypeCode: 'MQS',
          thresholdTypeDesc: 'Medallion Qualifying Segments',
          thresholdAmt: 30,
          balanceAmt: 0,
          remainderAmt: 30,
          percentCompleteNum: '0.0%',
          percentRemainderNum: '100.0%',
          thresholdMet: false
        },
        {
          thresholdTypeCode: 'MQDs',
          thresholdTypeDesc: 'Medallion Qualifying Dollars',
          thresholdAmt: 3000,
          balanceAmt: 0,
          remainderAmt: 3000,
          percentCompleteNum: '0.0%',
          percentRemainderNum: '100.0%',
          thresholdMet: false
        },
        {
          thresholdTypeCode: 'COB',
          thresholdTypeDesc: 'Cobrand - MQD Waiver',
          thresholdAmt: 25000,
          spendPartnerCode: 'AXS',
          balanceAmt: 0,
          remainderAmt: 25000,
          percentCompleteNum: '0.0%',
          percentRemainderNum: '100.0%',
          thresholdMet: false
        }
      ]
    }
  ]
};

export const StatusTrackerResponseWithoutFutureFlightsMocks: StatusTrackerResponse =
  {
    loyaltyMemberId: '6228453988',
    carrierCode: 'DL',
    countryCode: 'US',
    personName: {
      namePrefixCode: 'Ms',
      firstName: 'Digital',
      lastName: 'Platinum'
    },
    enrolledInPromotionalStatus: false,
    hasFutureFlights: false,
    futureFlightCnt: 0,
    loyaltyMemberAnnualBalances: [
      {
        balanceStartLocalDate: '2023',
        loyaltyBalances: [
          {
            balanceTypeCode: 'CFM',
            balanceTypeDesc: 'Credited Flight Miles',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'MQDs',
            balanceTypeDesc: 'Medallion Qualifying Dollars',
            balanceAmt: 25000
          },
          {
            balanceTypeCode: 'COB',
            balanceTypeDesc: 'Cobrand - MQD Waiver',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'ROLL',
            balanceTypeDesc: 'Rollover MQMs',
            balanceAmt: 0
          }
        ]
      },
      {
        balanceStartLocalDate: '2022',
        loyaltyBalances: [
          {
            balanceTypeCode: 'CFM',
            balanceTypeDesc: 'Credited Flight Miles',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'MQM',
            balanceTypeDesc: 'Medallion Qualifying Miles',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'MQS',
            balanceTypeDesc: 'Medallion Qualifying Segments',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'MQDs',
            balanceTypeDesc: 'Medallion Qualifying Dollars',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'COB',
            balanceTypeDesc: 'Cobrand - MQD Waiver',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'ROLL',
            balanceTypeDesc: 'Rollover MQMs',
            balanceAmt: 0
          }
        ]
      },
      {
        balanceStartLocalDate: '2021',
        loyaltyBalances: [
          {
            balanceTypeCode: 'CFM',
            balanceTypeDesc: 'Credited Flight Miles',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'MQM',
            balanceTypeDesc: 'Medallion Qualifying Miles',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'MQS',
            balanceTypeDesc: 'Medallion Qualifying Segments',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'MQDs',
            balanceTypeDesc: 'Medallion Qualifying Dollars',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'COB',
            balanceTypeDesc: 'Cobrand - MQD Waiver',
            balanceAmt: 0
          },
          {
            balanceTypeCode: 'ROLL',
            balanceTypeDesc: 'Rollover MQMs',
            balanceAmt: 0
          }
        ]
      }
    ],
    loyaltyMemberProgramBalance: {
      balanceStartLocalDate: '1995-10-20',
      loyaltyBalances: [
        {
          balanceTypeCode: 'LCFM',
          balanceTypeDesc: 'Lifetime Credited Flight Miles',
          balanceAmt: 50510
        },
        {
          balanceTypeCode: 'LMQMs',
          balanceTypeDesc:
            'Lifetime Medallion Qualifying Miles (aka Million Miler)',
          balanceAmt: 750000
        },
        {
          balanceTypeCode: 'AVAIL',
          balanceTypeDesc: 'Available Miles',
          balanceAmt: 75296
        },
        {
          balanceTypeCode: 'TOTPGM',
          balanceTypeDesc: 'Total Program Miles',
          balanceAmt: 75296
        }
      ]
    },
    loyaltyMemberTierLevels: [
      {
        tierStatusDesc: 'PREVIOUS - 1',
        tierLevelClassificatinCode: 'MB',
        tierLevelCode: 'FF',
        tierLevelCodeDesc: 'SkyMiles Member',
        tierLevelStartLocalDate: '2021-02-01',
        tierLevelEndLocalDate: '2022-01-31',
        tierComp: false,
        tierMethodOfAttainmentCode: 'B2ET'
      },
      {
        tierStatusDesc: 'PREVIOUS',
        tierLevelClassificatinCode: 'MB',
        tierLevelCode: 'FF',
        tierLevelCodeDesc: 'SkyMiles Member',
        tierLevelStartLocalDate: '2022-02-01',
        tierLevelEndLocalDate: '2023-01-31',
        tierComp: false,
        tierMethodOfAttainmentCode: 'B2ET'
      },
      {
        tierStatusDesc: 'CURRENT',
        tierLevelClassificatinCode: 'MB',
        tierLevelCode: 'PM',
        tierLevelCodeDesc: 'Platinum Medallion',
        tierLevelStartLocalDate: '2023-02-01',
        tierLevelEndLocalDate: '2024-01-31',
        tierComp: false,
        tierMethodOfAttainmentCode: 'EPN23D'
      },
      {
        tierStatusDesc: 'FUTURE',
        tierLevelClassificatinCode: 'MB',
        tierLevelCode: 'PM',
        tierLevelCodeDesc: 'Platinum Medallion',
        tierLevelStartLocalDate: '2025-02-01',
        tierLevelEndLocalDate: '2026-01-31',
        tierComp: false,
        tierMethodOfAttainmentCode: 'EPN23P'
      },
      {
        tierStatusDesc: 'FUTURE-FUTURE',
        tierLevelClassificatinCode: 'MB',
        tierLevelCode: 'FF',
        tierLevelCodeDesc: 'SkyMiles Member',
        tierLevelStartLocalDate: '2025-02-01',
        tierLevelEndLocalDate: '2026-01-31',
        tierComp: false
      }
    ],
    currentLoyaltyMemberMedallionStatus: [
      {
        programYearNum: '2024',
        programYearDesc: 'CURRENT',
        programYearStartLocalDate: '2024-02-01',
        programYearEndLocalDate: '2023-01-31',
        earnYearStartLocalDate: '2023-01-01',
        earnYearEndLocalDate: '2023-12-31',
        regionCode: 'ALL',
        eligibleMQDWaiver: false
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQD WAIVER'
          }
        ]
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQDs'
          }
        ]
      },
      {
        trackingToTierLevelCode: 'PM',
        trackingToTierLevelDesc: 'Platinum'
      },
      {
        loyaltyMemberThresholds: [
          {
            thresholdTypeCode: 'MQDs',
            thresholdTypeDesc: 'Medallion Qualifying Dollars',
            thresholdAmt: 18000,
            balanceAmt: 15300,
            remainderAmt: 2700,
            percentCompleteNum: '85.0%',
            percentRemainderNum: '15.0%',
            thresholdMet: false
          }
        ]
      }
    ],
    previousLoyaltyMemberMedallionStatus: [
      {
        programYearNum: '2023',
        programYearDesc: 'PREVIOUS',
        programYearStartLocalDate: '2023-02-01',
        programYearEndLocalDate: '2024-01-31',
        earnYearStartLocalDate: '2022-01-01',
        earnYearEndLocalDate: '2022-12-31',
        regionCode: 'US',
        eligibleMQDWaiver: false
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQS and MQD WAIVER'
          }
        ]
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQS and MQD'
          }
        ]
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQM and MQD WAIVER'
          }
        ]
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQM and MQD'
          }
        ]
      },
      {
        trackingToTierLevelCode: 'FO',
        trackingToTierLevelDesc: 'Silver'
      },
      {
        loyaltyMemberThresholds: [
          {
            thresholdTypeCode: 'MQM',
            thresholdTypeDesc: 'Medallion Qualifying Miles',
            thresholdAmt: 25000,
            balanceAmt: 0,
            remainderAmt: 25000,
            percentCompleteNum: '0.0%',
            percentRemainderNum: '100.0%',
            thresholdMet: false
          },
          {
            thresholdTypeCode: 'MQS',
            thresholdTypeDesc: 'Medallion Qualifying Segments',
            thresholdAmt: 30,
            balanceAmt: 0,
            remainderAmt: 30,
            percentCompleteNum: '0.0%',
            percentRemainderNum: '100.0%',
            thresholdMet: false
          },
          {
            thresholdTypeCode: 'COB',
            thresholdTypeDesc: 'Cobrand - MQD Waiver',
            thresholdAmt: 25000,
            spendPartnerCode: 'AXS',
            balanceAmt: 0,
            remainderAmt: 25000,
            percentCompleteNum: '0.0%',
            percentRemainderNum: '100.0%',
            thresholdMet: false
          }
        ]
      }
    ],
    previousMinus1LoyaltyMemberMedallionStatus: [
      {
        programYearNum: '2022',
        programYearDesc: 'PREVIOUS-1',
        programYearStartLocalDate: '2022-02-01',
        programYearEndLocalDate: '2023-01-31',
        earnYearStartLocalDate: '2021-01-01',
        earnYearEndLocalDate: '2021-12-31',
        regionCode: 'US',
        eligibleMQDWaiver: false
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQS and MQD WAIVER'
          }
        ]
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQS and MQD'
          }
        ]
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQM and MQD WAIVER'
          }
        ]
      },
      {
        medallionThresholdCombinations: [
          {
            thresholdCombinationDesc: 'MQM and MQD'
          }
        ]
      },
      {
        trackingToTierLevelCode: 'FO',
        trackingToTierLevelDesc: 'Silver'
      },
      {
        loyaltyMemberThresholds: [
          {
            thresholdTypeCode: 'MQM',
            thresholdTypeDesc: 'Medallion Qualifying Miles',
            thresholdAmt: 25000,
            balanceAmt: 0,
            remainderAmt: 25000,
            percentCompleteNum: '0.0%',
            percentRemainderNum: '100.0%',
            thresholdMet: false
          },
          {
            thresholdTypeCode: 'MQS',
            thresholdTypeDesc: 'Medallion Qualifying Segments',
            thresholdAmt: 30,
            balanceAmt: 0,
            remainderAmt: 30,
            percentCompleteNum: '0.0%',
            percentRemainderNum: '100.0%',
            thresholdMet: false
          },
          {
            thresholdTypeCode: 'MQDs',
            thresholdTypeDesc: 'Medallion Qualifying Dollars',
            thresholdAmt: 3000,
            balanceAmt: 0,
            remainderAmt: 3000,
            percentCompleteNum: '0.0%',
            percentRemainderNum: '100.0%',
            thresholdMet: false
          },
          {
            thresholdTypeCode: 'COB',
            thresholdTypeDesc: 'Cobrand - MQD Waiver',
            thresholdAmt: 25000,
            spendPartnerCode: 'AXS',
            balanceAmt: 0,
            remainderAmt: 25000,
            percentCompleteNum: '0.0%',
            percentRemainderNum: '100.0%',
            thresholdMet: false
          }
        ]
      }
    ]
  };

export const CommonRequestMocks: CommonRequest = {
  carrierCode: 'DL',
  retry: 0,
  timeout: 30000
};
